<template>
  <div :class="types=='home'?'inl':''">
    <div v-if="LotteryLatelyLpVo.length>1">
      <div class="lotterytime" v-if="types=='lottery'">
        <template v-if="dateNumb.length>6">
          <span class="blackbgc">{{dateNumb[0]+""+dateNumb[1+""+dateNumb[2]]}}</span>
          时
          <span class="blackbgc">{{dateNumb[3]+""+dateNumb[4]}}</span>
          分
          <span class="blackbgc">{{dateNumb[5]+""+dateNumb[6]}}</span>
          秒
        </template>
        <template v-else>
          <span class="blackbgc">{{dateNumb[0]+""+dateNumb[1]}}</span>
          时
          <span class="blackbgc">{{dateNumb[2]+""+dateNumb[3]}}</span>
          分
          <span class="blackbgc">{{dateNumb[4]+""+dateNumb[5]}}</span>
          秒
        </template>
      </div>
      <div class="hometime" v-else-if="types=='home'">
        <template v-if="dateNumb.length>6">
          <span class="redtime">{{dateNumb[0]+""+dateNumb[1+""+dateNumb[2]]}}</span>
          时
          <span class="redtime">{{dateNumb[3]+""+dateNumb[4]}}</span>
          分
          <span class="redtime">{{dateNumb[5]+""+dateNumb[6]}}</span>
          秒
        </template>
        <template v-else>
          <span class="redtime">{{dateNumb[0]+""+dateNumb[1]}}</span>
          <span class="redtime">时</span>
          <span class="redtime">{{dateNumb[2]+""+dateNumb[3]}}</span>
          <span class="redtime">分</span>
          <span class="redtime">{{dateNumb[4]+""+dateNumb[5]}}</span>
          <span class="redtime">秒</span>
        </template>
      </div>
    </div>
    <div v-else>
      <div v-if="types=='lottery'" class="kaijiangzhonglottery">开奖中...</div>
      <div v-else-if="types=='home'" class="kaijiangzhonghome">开奖中...</div>
    </div>
  </div>
</template>
<script>
import * as Time from "~/assets/libs/timeOptions";
export default {
  name: "count-down",
  data() {
    return {
      date: Time.checkDateType(this.endDate)
    };
  },
  props: {
    endDate: {
      type: [String, Object, Date, Number],
      default: null
    },
    types: {
      type: [String],
      default: "home"
    },
    lottery: {
      type: [Object],
      default: null
    }
  },
  watch: {
    endDate() {
      this.date = Time.checkDateType(this.endDate);
    }
  },
  mounted() {
  },
  computed: {
    //当前服务器时间
    leftTime() {
      return Time.checkDateType(this.$store.getters["service/getServiceTime"]);
    },
    dateNumb() {
      if (this.leftTime.getTime() == 0) {
        // console.log(this.leftTime)
        return `000000`;
      }
      //结束时间 - 当前时间
      if (this.date == null) return `000000`;

      let lastTime = this.date.getTime() - this.leftTime.getTime();
      if (lastTime <= 0) {
        this.$emit("endCountDown", this.date);
        return `000000`;
      }
      //没有天 所以不%24
      // var hours = parseInt(lastTime / (1000 * 60 * 60) % 24 , 10); //计算剩余的小时
      var hours = parseInt(lastTime / (1000 * 60 * 60), 10); //计算剩余的小时
      var minutes = parseInt((lastTime / 1000 / 60) % 60, 10); //计算剩余的分钟
      var seconds = parseInt((lastTime / 1000) % 60, 10); //计算剩余的秒数

      if (hours <= 9) hours = `0${hours}`;
      if (minutes <= 9) minutes = `0${minutes}`;
      if (seconds <= 9) seconds = `0${seconds}`;

      // console.log('time:',`${hours}:${minutes}:${seconds}`)

      return `${hours}${minutes}${seconds}`;
    },
    // 开奖中
    LotteryLatelyLpVo() {
      if (this.lottery) {
        return this.lottery.drawingNumber
          ? this.lottery.drawingNumber.split(",")
          : [];
      } else {
        return [];
      }
    }
  },
  created() {
    // this.$store.dispatch("service/getServiceTime"); // 获取服务器时间
  }
};
</script>

<style lang="less" scoped>
.lotterytime {
  width: 100%;
  height: 40px;
  line-height: 40px;
  .blackbgc {
    display: inline-block;
    width: 40px;
    line-height: 40px;
    background-color: #444553;
    color: #ffd200;
    text-align: center;
  }
}
.hometime {
  display: inline-block;
  .redtime {
    color: red;
    font-size: 14px;
    margin: 0 2px;
  }
}
.kaijiangzhonglottery {
  width: 190px;
  height: 40px;
  line-height: 40px;
  padding-left: 30px;
  font-size: 18px;
  background-color: #444553;
  color: #f7f200;
}
.inl {
  display: inline-block;
  margin-left: 20px;
  .kaijiangzhonghome {
    color: red;
  }
}
</style>
